import React, { useState } from 'react'
import {
  Box,
  Button,
  makeStyles,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core'
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { showToast } from '../../../../../utils/toast';
import { announcementAPI } from '../../../../../api/adminApi';

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(3),
    backgroundColor: "#0f0f0f",
    minHeight: "100vh",
    color: "#fff",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(3),
  },
  quill: {
    "& .ql-snow .ql-picker-options": {
      backgroundColor: "#121212",
    },
    "& .ql-container": {
      backgroundColor: "#121212",
      color: "#fff",
    },
    "& .ql-toolbar button:hover, & .ql-toolbar .ql-picker-label:hover": {
      color: "#FE5A97",
    },
    "& .ql-toolbar button.ql-active, & .ql-toolbar .ql-picker-label.ql-active": {
      color: "#FE5A97",
    },
    "& .ql-editor": {
      minHeight: "200px",
      color: "#fff",
    },
    "& .ql-toolbar": {
      backgroundColor: "#1e1e1e",
      border: "none",
      "& button, & .ql-picker": {
        color: "#fff",
      },
    },
  },
}))

export default function AdminUpdateCenter() {
  const classes = useStyles();
  const [content, setContent] = useState("");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleOpenConfirm = () => setConfirmOpen(true);
  const handleCloseConfirm = () => setConfirmOpen(false);

  const handleConfirmSend = async () => {
    await handleSendAnnouncement();
  };

  const handleSendAnnouncement = async () => {
    setLoading(true);
    try {
      const response = await announcementAPI(content);

      if (response.success) {
        showToast("Announcement sent successfully", "success");
        setContent("");
        setConfirmOpen(false);
      } else {
        showToast("Failed to send announcement", "error");
      }
    } catch (error) {
      console.error("Error sending announcement:", error);
      showToast("Error sending announcement", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className={classes.container}>
      <Box className={classes.header}>
        <Typography variant="h4" style={{ color: "#FE5A97" }}>
          Product Updates & Launches
        </Typography>
      </Box>
      <Typography style={{ width: "80%" }}>
        Create and publish announcements about new features and product updates.
        All messages from this section will be automatically sent to every user
      </Typography>

      <Box mt={3} className={classes.quill}>
        <ReactQuill
          theme="snow"
          value={content}
          onChange={setContent}
          placeholder="Write your announcement here..."
        />
      </Box>

      <Button
        variant="contained"
        style={{ backgroundColor: "#FE5A97", color: "#fff", marginTop: 20 }}
        onClick={handleOpenConfirm}
        disabled={loading || !content.trim()}
      >
        {loading ? "Sending..." : "Send Announcement"}
      </Button>

      {/* Confirmation Dialog */}
      <Dialog open={confirmOpen} onClose={handleCloseConfirm}>
        <DialogTitle style={{ color: "#fff" }}>Confirm Send</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to send this announcement to all users?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirm} color="default" disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirmSend}
            style={{ backgroundColor: "#FE5A97", color: "#fff" }}
            disabled={loading}
          >
            {loading ? "Sending..." : "Confirm"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
